// import React from "react";
// import Select from "react-select";
// import styled from "styled-components";
// import _ from "lodash";

// /**
//  * Height and width dropdowns for custom size selection
//  * Functions found in SizeSelector.js
//  *
//  * @param {Object}    state         React state from parent component
//  * @param {function}  updateHeight  Function to update height value
//  * @param {function}  updateWidth   Function to update width value
//  *
//  * @returns {Object}
//  */
// export default function CustomSizeDropdown({
//   state,
//   updateHeight,
//   updateWidth,
// }) {
//   // Get dropdown range for sizes
//   const minSize = state.features.minSingleCanvasSize;
//   const maxSize = state.features.maxSingleCanvasHeight;
//   const options = _.range(minSize, maxSize).map((size) => ({
//     label: size,
//     value: size,
//   }));

//   // Get selected values
//   const selectedHeight = options.find(
//     (option) => option.value === state.selectedHeight
//   );
//   const selectedWidth = options.find(
//     (option) => option.value === state.selectedWidth
//   );

//   return (
//     <Container>
//       <OptionNameContainer>
//         {(window.is_ab_custom_pdp && (
//           <OptionNameAB>Custom Size up to 60"</OptionNameAB>
//         )) || <OptionName>Custom Size up to 60"</OptionName>}
//       </OptionNameContainer>

//       <SelectContainer>
//         <SelectContainerInner>
//           <Select
//             onChange={updateHeight}
//             name="Height"
//             options={options}
//             placeholder="H"
//             value={selectedHeight}
//           />
//         </SelectContainerInner>

//         <XContainer>X</XContainer>

//         <SelectContainerInner>
//           <Select
//             onChange={updateWidth}
//             name="Width"
//             options={options}
//             placeholder="W"
//             value={selectedWidth}
//           />
//         </SelectContainerInner>
//       </SelectContainer>

//       {state.customProduct && (
//         <SelectedLabel>
//           {state.selectedHeight}" x {state.selectedWidth}" - $
//           {state.customProduct.variants[0].price}
//         </SelectedLabel>
//       )}
//     </Container>
//   );
// }

// const Container = styled.div`
//   text-align: left;
//   padding-bottom: 24px;
// `;
// const OptionName = styled.p`
//   margin: 0;
//   font-size: 14px;
//   font-family: "Sofia Pro";
// `;
// const OptionNameAB = styled.p`
//   margin: 0;
//   font-size: 16px;
//   font-family: Assistant, sans-serif;
//   color: #02455d;
//   font-weight: 400;
// `;
// const OptionNameContainer = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: flex-start;
//   gap: 8px;
//   font-size: 14px;
//   padding-bottom: 8px;
// `;
// const SelectContainer = styled.div`
//   display: flex;
//   flex-wrap: no-wrap;
//   align-items: center;
// `;
// const SelectContainerInner = styled.div`
//   width: 80px;
// `;
// const XContainer = styled.span`
//   padding: 0 16px;
//   font-size: 18px;
//   font-weight: 400;
// `;
// const SelectedLabel = styled.p`
//   margin: 0;
//   font-weight: 800;
//   padding-top: 16px;
//   padding-left: 5px;
//   font-size: 18px;
// `;
